import { useGlobalState } from '@exodus/headless-react';
const DEFAULT_SLIPPAGE = 2;
const useSlippage = () => useGlobalState({
    namespace: 'exchange',
    key: 'slippage',
    defaultValue: DEFAULT_SLIPPAGE,
    persist: true,
});
export default useSlippage;
